import Events from 'marketing-website/media/images/pages/resources/events@2x.png';
import Product from 'marketing-website/media/images/pages/resources/product-updates@2x.png';
import Guides from 'marketing-website/media/images/pages/resources/resources@2x.png';

const assets = {
  events: {
    alt: 'events',
    src: Events,
  },
  product: {
    alt: 'product updates',
    src: Product,
  },
  guides: {
    alt: 'assets and guides',
    src: Guides,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/resources/assets.js